import React from 'react';
import { PrimaryButton, Sub1Button } from '@components/atoms';
import { useSetRecoilState } from 'recoil';
import { dialogContentsState } from '@components/templates/Dialog';
import { submitDebounce } from '../lib';

const useStaticDialog = () => {
  const setDialogContents = useSetRecoilState(dialogContentsState);

  /**
   * submit 최종 confirm layer
   * @param postCB
   */
  const confirmTurnOnOffDialog = (status: string, onCB: () => void, offCB: () => void) => {
    setDialogContents({
      type: 'plain',
      body: `Are you sure you want to turn ${status}? \n\r(You must click Submit for the changes to take effect.)`,
      footer: (
        <>
          <Sub1Button
            onClick={() => {
              setDialogContents({ type: 'hidden' });
              offCB && offCB();
            }}
          >
            {`No, I don't`}
          </Sub1Button>
          <PrimaryButton
            onClick={async () => {
              setDialogContents({ type: 'hidden' });
              onCB && onCB();
            }}
          >
            Yes, turn {status}
          </PrimaryButton>
        </>
      ),
    });
  };
  /**
   * submit 최종 confirm layer
   * @param postCB
   */
  const submitConfirmDialog = (postCB: () => void) => {
    setDialogContents({
      type: 'plain',
      body: `Do you want to save changes?`,
      footer: (
        <>
          <Sub1Button
            onClick={() => {
              setDialogContents({ type: 'hidden' });
            }}
          >
            Cancel
          </Sub1Button>
          <PrimaryButton
            onClick={submitDebounce(() => {
              postCB();
              setDialogContents({ type: 'hidden' });
            })}
          >
            Save
          </PrimaryButton>
        </>
      ),
    });
  };

  /**
   * submit 최종 confirm layer
   * @param postCB
   */
  const confirmTurnAutomaticallyOnOffDialog = (status: string, onCB: () => void, offCB: () => void) => {
    const message =
      status.toLowerCase() === 'on'
        ? 'Are you sure you want to turn on?'
        : 'Are you sure you want to turn off automatically send?';

    setDialogContents({
      type: 'plain',
      body: `${message} \n\r(You must click Submit for the changes to take effect.)`,
      footer: (
        <>
          <Sub1Button
            onClick={() => {
              setDialogContents({ type: 'hidden' });
              offCB && offCB();
            }}
          >
            {`No, I don't`}
          </Sub1Button>
          <PrimaryButton
            onClick={async () => {
              setDialogContents({ type: 'hidden' });
              onCB && onCB();
            }}
          >
            Yes, turn {status}
          </PrimaryButton>
        </>
      ),
    });
  };

  return {
    submitConfirmDialog,
    confirmTurnOnOffDialog,
    confirmTurnAutomaticallyOnOffDialog,
  };
};

export default useStaticDialog;
